import { Route, Switch, Redirect } from "wouter";
import { Landing } from "./routes/landing";
import { Login } from "./routes/login";
import { Dashboard } from "./routes/dashboard";
import { Suppliers } from "./routes/suppliers";
import { Orders } from "./routes/orders";
import { Invoices } from "./routes/invoices";
import { Settings } from "./routes/settings";
import { AppShell } from "./components/AppShell";

export function App() {
  return (
    <Switch>
      <Route path="/" component={Landing} />
      <Route path="/login" component={Login} />
      <Route path="/app">{() => <Redirect to="/app/dashboard" />}</Route>
      <Route path="/app/dashboard"><AppShell><Dashboard /></AppShell></Route>
      <Route path="/app/orders"><AppShell><Orders /></AppShell></Route>
      <Route path="/app/orders/placed"><AppShell><Orders subtab="placed" /></AppShell></Route>
      <Route path="/app/orders/pendingApproval"><AppShell><Orders subtab="pending" /></AppShell></Route>
      <Route path="/app/suppliers"><AppShell><Suppliers /></AppShell></Route>
      <Route path="/app/invoices"><AppShell><Invoices /></AppShell></Route>
      <Route path="/app/settings"><AppShell><Settings /></AppShell></Route>
      <Route>
        <div className="min-h-[100dvh] grid place-items-center text-ink-mute">
          <div>404 — try <a className="text-nomni-deep underline" href="/">home</a></div>
        </div>
      </Route>
    </Switch>
  );
}
